module.exports = __webpack_public_path__ + "static/media/bg11.58864dcd.jpg";